import React from 'react'

import { DocsSection } from '@/components/common/docs-section'
import { docsClipsLinksIndex } from '@/config/links'

import WhatAreClips from './what-are-clips.mdx'
import Library from './library.mdx'
import ContentSafety from './content-safety.mdx'
import { Endpoints } from './endpoints'
import ResponseSchema from './response-schema.mdx'
import Examples from './examples.mdx'

export const Clips: React.FC = () => {
  return (
    <div>
      <WhatAreClips />
      <DocsSection
        anchorId={docsClipsLinksIndex.library.hash}
        pathname={docsClipsLinksIndex.library.pathname}
      >
        <Library />
      </DocsSection>
      <DocsSection
        anchorId={docsClipsLinksIndex.contentSafety.hash}
        pathname={docsClipsLinksIndex.contentSafety.pathname}
      >
        <ContentSafety />
      </DocsSection>
      <DocsSection
        anchorId={docsClipsLinksIndex.endpoints.hash}
        pathname={docsClipsLinksIndex.endpoints.pathname}
      >
        <Endpoints />
      </DocsSection>
      <DocsSection
        anchorId={docsClipsLinksIndex.responseSchema.hash}
        pathname={docsClipsLinksIndex.responseSchema.pathname}
      >
        <ResponseSchema />
      </DocsSection>
      <DocsSection
        anchorId={docsClipsLinksIndex.examples.hash}
        pathname={docsClipsLinksIndex.examples.pathname}
      >
        <Examples />
      </DocsSection>
    </div>
  )
}
